import axios from "axios";
import {
  IBike,
  IBikeCreateDto,
  IBikeRents,
  IBikeWithHistory,
} from "../types/bikes.type";
import { IClient, IClientCreateDto } from "../types/clients.type";
import { IHistory } from "../types/history.type";
import { IItems, IItemWriteOfToBike } from "../types/items.type";
import { IOrder, IOrderCreateDto, IOrderUpdateDto } from "../types/order.type";
import { IProduct, IProductCreateDto } from "../types/product.type";
import {
  IProduction,
  IProductionCreateDto,
  IProductionUpdateDto,
  IWriteOffWarehouse,
} from "../types/production.type";
import { IRent, IRentCreateDto, IRentUpdateDto } from "../types/rent.type";
import { IResource, IResourceCreateDto } from "../types/resources.type";
import { ISpendingEditNote, ISpendingOff } from "../types/spending.type";
import { IStatistics } from "../types/statistics.type";
import { ISupplier, ISupplierCreateDto } from "../types/suppliers.type";
import {
  IReturnWarehouse,
  IWarehouse,
  IWarehouseCreateDto,
  IWarehouseOff,
} from "../types/warehouse.type";
import { BASE_URL } from "../utils/constants/api";
import {
  IEmployee,
  IEmployeeCreateDto,
  IEmployeeUpdateDto,
  ILoginResponse,
  IUser,
  IUserChangeDto,
  IUserCreateDto,
  IUserCreateResponse,
} from "./api.interface";
import { TerminalInterface } from "../types/terminal.type";
import { TerminalLockerLiveItem } from "../types/terminal-locker-live.type";
import {
  CellHistoryDateDto,
  CellHistoryInterface,
} from "../types/cell-history.type";
import {
  CalibrationHistoryDateDto,
  CalibrationHistoryInterface,
} from "../types/calibration.type";
import { TerminalEventInterface } from "../types/terminal-event.type";
import {
  BatteryCreateDto,
  BatteryType,
  BatteryUpdateDto,
} from "../types/battery.type";

export const unAuthApiService = {
  login: async (email: string, password: string): Promise<ILoginResponse> => {
    const response = await axios.post(
      `${BASE_URL}/auth/login`,
      {
        email,
        password,
      },
      { headers: { "ngrok-skip-browser-warning": "true" } }
    );
    return response.data;
  },
  confirmAuthentication: async (code: string): Promise<any> => {
    const response = await axios.post(
      `${BASE_URL}/auth/confirm-authorization-code`,
      { code }
    );
    return response.data;
  },
  confirmEmail: async (code: string, email: string): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/confirm-email`, {
      code,
      email,
    });
    return response.data;
  },
  sendNewCode: async (email: string): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/send-new-code`, {
      email,
    });
    return response.data;
  },
  endRegistrations: async (email: string) => {
    const response = await axios.post(`${BASE_URL}/email/end-registration`, {
      email,
    });
    return response.data;
  },
  changePassword: async (
    email: string,
    newPassword: string,
    confirmPassword: string,
    code: string
  ): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/change-password`, {
      email,
      newPassword,
      confirmPassword,
      code,
    });
    return response.data;
  },
  createNewPassword: async (
    newPassword: string,
    confirmPassword: string,
    code: string
  ): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/create-password`, {
      code,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },
};

export const authApiService = {
  getMe: async (): Promise<IUser | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token || token === "undefined") {
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(`${BASE_URL}/users/me`, config);
    return response.data;
  },

  getAllUsers: async (): Promise<IUser[] | undefined> => {
    const token = localStorage.getItem("accessToken");
    console.log("token", token);

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${BASE_URL}/users/all?orderBy=createdAt&orderType=ASC&per_page=100`,
      config
    );

    console.log(response);

    return response.data;
  },

  setUser: async (id: string, user: IUserChangeDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };
    const response = await axios.put(
      `${BASE_URL}/users/update/${id}`,
      user,
      config
    );

    return response.data;
  },

  deleteUser: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };
    const response = await axios.delete(`${BASE_URL}/users/${id}`, config);
    return response.data;
  },

  createUser: async (
    user: IUserCreateDto
  ): Promise<IUserCreateResponse | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/auth/register/`,
      user,
      config
    );

    return response.data;
  },

  getAllEmployee: async (): Promise<IEmployee[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/employee/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },

  createEmployee: async (employee: IEmployeeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/employee/create`,
      employee,
      config
    );

    return response.data;
  },

  updateEmployee: async (employee: IEmployeeUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/employee/update/${employee.id}`,
      employee,
      config
    );

    return response.data;
  },

  deleteEmployee: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/employee/delete/${id}`,
      config
    );

    return response.data;
  },

  uploadImage: async (formData: FormData) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    console.log(formData);

    const response = await axios.post(
      `${BASE_URL}/files/upload`,
      formData,
      config
    );

    return response.data;
  },

  getAllResources: async (): Promise<IResource[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/item/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },
  getTableResources: async (): Promise<IResource[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/item?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },
  createResource: async (
    resourse: IResourceCreateDto
  ): Promise<any | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/item/create`,
      resourse,
      config
    );

    return response.data;
  },
  deleteResource: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/item/delete/${id}`,
      config
    );

    return response.data;
  },

  updateResource: async (id: string, resource: IResourceCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/item/update/${id}`,
      resource,
      config
    );

    return response.data;
  },

  getAllSuppliers: async (): Promise<ISupplier[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/providers/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },

  createSupplier: async (body: ISupplierCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/providers/create`,
      body,
      config
    );

    return response.data;
  },

  updateSupplier: async (id: string, body: ISupplierCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/providers/update/${id}`,
      body,
      config
    );

    return response.data;
  },

  deleteSupplier: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/providers/delete/${id}`,
      config
    );

    return response.data;
  },

  getAllWarehouse: async (): Promise<IWarehouse[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/resources/all-with-relations?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },

  createWarehouse: async (body: IWarehouseCreateDto[]) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/warehouses/create/resource-warehouse`,
      body,
      config
    );

    return response.data;
  },

  updateWarehouse: async (id: string, body: IWarehouseCreateDto[]) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/warehouses/update/resource-warehouse/${id}`,
      body,
      config
    );

    return response.data;
  },

  deleteWarehouse: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/warehouses/delete/resource-warehouse/${id}`,
      config
    );

    return response.data;
  },

  getAllClients: async (options?: {
    onlyWithCellAccess?: boolean;
  }): Promise<IClient[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const params = new URLSearchParams({
      orderBy: "createdAt",
      orderType: "ASC",
      per_page: "10000",
    });
    if (options?.onlyWithCellAccess) {
      params.set("filterBy", "cellAccess");
      params.set("filterValue", "true");
      params.set("filterType", "eq");
    }

    const response = await axios.get(
      `${BASE_URL}/clients/all?${params.toString()}`,
      config
    );

    return response.data;
  },
  createClient: async (body: IClientCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/clients/create`,
      body,
      config
    );

    return response.data;
  },
  updateClient: async (id: string, body: IClientCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/clients/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteClient: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/clients/delete/${id}`,
      config
    );

    return response.data;
  },
  getAllProducts: async (): Promise<IProduct[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/wares/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },
  createProduct: async (body: IProductCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${BASE_URL}/wares/create`, body, config);

    return response.data;
  },
  updateProduct: async (id: string, body: IProductCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/wares/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteProduct: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/wares/delete/${id}`,
      config
    );

    return response.data;
  },
  getAllOrders: async (): Promise<IOrder[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/orders/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data.data;
  },
  createOrder: async (body: IOrderCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/orders/create`,
      body,
      config
    );

    return response.data;
  },
  updateOrder: async (id: string, body: IOrderCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/orders/update/${id}`,
      body,
      config
    );

    return response.data;
  },

  updateStatusOrder: async (id: string, body: IOrderUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/orders/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteOrder: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/orders/delete/${id}`,
      config
    );

    return response.data;
  },

  getAllProduction: async (): Promise<IProduction[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/production/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data;
  },
  createProduction: async (body: IProductionCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/production/create`,
      body,
      config
    );

    return response.data;
  },
  updateProduction: async (id: string, body: IProductionUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/production/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  // updateProduction: async (id: string, body: IProductionCreateDto) => {

  // }
  writeOffResource: async (id: string, body: IWriteOffWarehouse) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/production/update/${id}/with-warehouse-management`,
      body,
      config
    );

    return response.data;
  },
  getAllHistory: async (): Promise<IHistory[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/history/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data.data;
  },
  writeOffResourceFromWarehouse: async (body: IWarehouseOff) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/production/write-off-resources`,
      body,
      config
    );

    return response.data;
  },
  uploadCdnImage: async (formData: FormData) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    console.log(formData);

    const response = await axios.post(
      `${BASE_URL}/files-cdn/upload`,
      formData,
      config
    );

    return response.data;
  },
  getAllBikes: async (): Promise<IBike[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/bike/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data;
  },
  getBatteries: async (): Promise<BatteryType[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/battery/all?orderBy=lastUpdatedAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data;
  },
  getBatteryById: async (id: string): Promise<BatteryType | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(`${BASE_URL}/admin/battery/${id}`, config);

    return response.data;
  },
  requestBatteryStatus: async (
    id: string
  ): Promise<
    | {
        requested: boolean;
        wsDelivered: boolean;
        terminalId: string;
        batteryMac: string;
      }
    | undefined
  > => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/admin/battery/${id}/request-status`,
      {},
      config
    );

    return response.data;
  },
  addBatteryComment: async (
    id: string,
    body: { text: string; file?: string | null }
  ): Promise<BatteryType | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/admin/battery/${id}/comment`,
      body,
      config
    );

    return response.data;
  },
  createBattery: async (
    body: BatteryCreateDto
  ): Promise<BatteryType | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${BASE_URL}/admin/battery`, body, config);

    return response.data;
  },
  updateBattery: async (
    id: string,
    body: BatteryUpdateDto
  ): Promise<BatteryType | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/admin/battery/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteBattery: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/admin/battery/${id}`,
      config
    );

    return response.data;
  },
  createBike: async (body: IBikeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${BASE_URL}/bike/create`, body, config);

    return response.data;
  },
  updateBike: async (id: string, body: IBikeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/bike/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  getOneBike: async (id: string): Promise<IBikeWithHistory | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(`${BASE_URL}/bike/one/${id}`, config);

    return response.data;
  },
  getAllItems: async (): Promise<IItems[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/item/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data;
  },
  writeOfItemsToBike: async (body: IItemWriteOfToBike) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/spending/write-off-to-bike`,
      body,
      config
    );

    return response.data;
  },
  spendingOff: async (body: ISpendingOff) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/spending/write-off`,
      body,
      config
    );

    return response.data;
  },
  getRentsByDate: async (
    dateFrom: string,
    dateTo: string
  ): Promise<IRent[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/rent/all-with-dates?dateFrom=${dateFrom}&dateTo=${dateTo}&per_page=1000000`,
      config
    );

    return response.data;
  },
  getAvaliablesBikes: async (
    dateFrom: string,
    dateTo: string
  ): Promise<IBikeRents[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/bike/all-available?dateFrom=${dateFrom}&dateTo=${dateTo}`,
      config
    );

    return response.data;
  },
  createRent: async (body: IRentCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${BASE_URL}/rent/create`, body, config);

    return response.data;
  },
  updateRent: async (id: string, body: IRentUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/rent/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  getStatistics: async (
    dateFrom: string,
    dateTo: string
  ): Promise<IStatistics | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/statistics/all?dateFrom=${dateFrom}&dateTo=${dateTo}`,
      config
    );

    return response.data;
  },
  returnWarehouse: async (body: IReturnWarehouse) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/spending/return-to-warehouse`,
      body,
      config
    );

    return response.data;
  },
  editSpendingNote: async (id: string, body: ISpendingEditNote) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };
    const response = await axios.put(
      `${BASE_URL}/spending/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  getTerminals: async (): Promise<TerminalInterface[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(`${BASE_URL}/admin/terminal/all`, config);

    return response.data;
  },
  getTerminalLockerLive: async (): Promise<
    TerminalLockerLiveItem[] | undefined
  > => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/terminal-locker/live`,
      config
    );

    return response.data;
  },
  openTerminalLockerCell: async (
    terminal_id: string,
    cell_id: number
  ): Promise<{ ok: boolean } | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/admin/terminal-locker/open-cell`,
      { terminal_id, cell_id },
      config
    );

    return response.data;
  },
  getCellHistoryDates: async (
    terminal_id: string
  ): Promise<CellHistoryDateDto[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/cell-history/dates/${terminal_id}`,
      config
    );

    return response.data;
  },
  getHistoryById: async (
    cell_id: string
  ): Promise<CellHistoryInterface | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/cell-history/${cell_id}`,
      config
    );

    return response.data;
  },

  getCalibrationHistoryDates: async (
    terminal_id: string
  ): Promise<CalibrationHistoryDateDto[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/calibration-history/dates/${terminal_id}`,
      config
    );

    return response.data;
  },

  getCalibrationById: async (
    id: string
  ): Promise<CalibrationHistoryInterface | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/calibration-history/${id}`,
      config
    );

    return response.data;
  },
  getTerminalEvents: async (
    terminal_id: string,
    pageToLoad: number,
    perPage: number
  ): Promise<
    | {
        data: TerminalEventInterface[];
        total: number;
        page: number;
        perPage: number;
        pageCount: number;
      }
    | undefined
  > => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/admin/terminal-event?page=${pageToLoad}&per_page=${perPage}&filterBy=terminal_id&filterValue=${terminal_id}&filterType=eq&orderBy=timestamp&orderType=DESC`,
      config
    );

    return response.data;
  },
  updateTerminal: async (id: string, body: any) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/admin/terminal/${id}`,
      body,
      config
    );

    return response.data;
  },
  requestTerminalBleScan: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/admin/terminal/${id}/request-ble-scan`,
      {},
      config
    );

    return response.data;
  },
  clearTerminalBleScanRequest: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    };

    // PUT already supported on bike-crm; dedicated clear endpoint after deploy.
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/terminal/${id}/clear-ble-scan-request`,
        {},
        config
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 404) {
        const response = await axios.put(
          `${BASE_URL}/admin/terminal/${id}`,
          { bleScanRequested: false },
          config
        );
        return response.data;
      }
      throw err;
    }
  },
};
